import React, { FC } from "react";
import layoutStyles from "./childrenModeGreetingLayout.module.scss";
import styles from "./ChildrenModeJungleGreeting.module.scss";

type ChildrenModeJungleGreetingProps = {
  title: string;
  subTitle: string;
};

export const ChildrenModeJungleGreeting: FC<ChildrenModeJungleGreetingProps> = ({
  title,
  subTitle,
}) => (
  <div className={layoutStyles.root}>
    <p className={styles.text}>{title}</p>
    <p className={styles.text}>{subTitle}</p>
  </div>
);
